import {
  Calendar,
  Download,
  Eye,
  FileSignature,
  FileText,
  GraduationCap,
  Upload,
  Wrench,
} from "lucide-react";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1590486803833-1c5dc8ddd4c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxwaG90b2dyYXBoZXIlMjBob2xkaW5nJTIwY2FtZXJhfGVufDB8fHx8MTc4NTc1Njk2NXww&ixlib=rb-4.1.0&q=85";

// Order here dictates render order on the photographer dashboard.
// `scheduling` is the LAST phase on purpose — it stays visually locked until
// every other item (documents, exam, tax & payments) + service area are done,
// then unlocks after the finale plays.
export const PHASES = [
  { key: "documents", label: "Documents", description: "Contracts, handbooks, style standards.", icon: FileText },
  { key: "exam", label: "Final Exam", description: "The last step — a short web-based exam to confirm you're ready.", icon: GraduationCap },
  { key: "tax_payments", label: "Tax & Payments", description: "Get set up to be paid on time.", icon: Wrench },
  { key: "scheduling", label: "Schedule Your Call", description: "Final step — book a time to meet with the Reelty team.", icon: Calendar },
];

export const ACTION_ICON = { review: Eye, sign: FileSignature, setup: Wrench, exam: GraduationCap, upload: Upload, schedule: Calendar };

// Big-CTA labels shown on each checklist card.
// NOTE: for `sign` and `upload` action types, the PRIMARY button is the
// document DOWNLOAD (so the photographer can print/sign the doc) — the
// actual upload action always renders as the SECONDARY (ghost) button.
// This is a UX rule requested by the client: uploading is never the visual
// centerpiece; getting the doc into the photographer's hands is.
export const ACTION_CTA = {
  review: { label: "View Document", icon: Eye },
  sign:   { label: "Download & Sign", icon: Download },
  setup:  { label: "Complete Setup", icon: Wrench },
  exam:   { label: "Take Exam", icon: GraduationCap },
  upload: { label: "Download", icon: Download },
  schedule: { label: "Book Call", icon: Calendar },
};

// Look up the CTA for a given item (action_type -> CTA meta).
export function ctaFor(item) {
  return ACTION_CTA[item.action_type] || ACTION_CTA.review;
}

export const truncate = (s, n) => (s && s.length > n ? s.slice(0, n - 1).trimEnd() + "…" : s);

export const formatBytes = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
